// apps/client/src/ui/hud/BellsPill.tsx — your bells; shown once pockets exist (M1), since there is nothing to spend before
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { Pill } from '../kit';
import { hasScreen } from '../router';
import { Coin } from './Icons';

export function BellsPill() {
  const t = useT();
  const bells = useGame((s) => s.you?.bells ?? 0);
  if (!hasScreen('pockets')) return null;
  return <span className="hud-raised"><Pill icon={<Coin />}><span className="num">{t('common.bells', { n: bells })}</span></Pill></span>;
}
